import { amount } from 'Shared/frontend/widgets/Amount';
import * as ImageSizes from 'Shared/model/ImageSizes';


export function calcHeight(height)
{
	if (height.parent) 
		return {height:'100%'};
	if (height.child) 
		return {height:'fit-content'};
	if (height.height) 
		return {height:amount(height.height)};
	if (height.ratio) 
		return {aspectRatio: lookupRatio(height)};
}

export function lookupRatio(ratioObj)
{
	if (ratioObj?.ratio=='custom')
		return ratioObj.customRatio;
	if (ratioObj?.ratio)
		return ImageSizes[ratioObj.ratio]?.ratio;
	return undefined;
}

